import GalleryStyle from '@/styles/components/careers/add-section/_index.module.scss';
import { Tooltip }  from '@/imports-files/pages/career/customize-career-page';
import { useTranslation } from 'react-i18next';

export function GallerySection({formik, sidebar_section, customizeCareerAction}){
  const {t} = useTranslation()
  function disableClass(formik) {
    return formik.values.page_sections_attributes.filter((section) => section.type == 'gallery').length >= 2 ? 'cursornone disabled' : ''
  }
  return(
    <div className = {`${GalleryStyle.Gallery}`}>
      <label className = {`${GalleryStyle.Gallery__Title}`}>{t('career:gallery')}</label>
      <div className = {`${GalleryStyle.Gallery__FirstOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'gallery', 'without_text', t)
          }}>
        <div className = {`${GalleryStyle.Gallery__Content}`}>
          <div className = {`${GalleryStyle.Gallery__Preview}`}>
              <div className = {`${GalleryStyle.Gallery__Image}`}>
                <img src = '/images/pages/career/gallery/page-gallery1.png'></img>
                <img src = '/images/pages/career/gallery/page-gallery2.png'></img>
                <img src = '/images/pages/career/gallery/page-gallery3.png'></img>
                <img src = '/images/pages/career/gallery/page-gallery4.png'></img>
                <img src = '/images/pages/career/gallery/page-gallery5.png'></img>
                <img src = '/images/pages/career/gallery/page-gallery6.png'></img>
              </div>
          </div>
        </div>
        <div className = {`${GalleryStyle.Gallery__AddBtn} noAddbtn__Inreorder`}>
          <span className={`${disableClass(formik)}`}>{t('button:add_section')}</span>
        </div>
      </div>
    </div>
  )
}